import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { KeyCodes } from '../../../../constants';
import { IDateInput } from '../../models';
import { MssFieldBaseFieldTypeComponent } from '../mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';

@Component({
  selector: 'lib-ff-date-input',
  styleUrls: ['./date-input.component.scss'],
  templateUrl: './date-input.component.html',
  imports: [...MSS_FORMLY_IMPORTS, FormsModule, ReactiveFormsModule],
})
export class FormlyDateInputComponent extends MssFieldBaseFieldTypeComponent implements OnInit {
  @ViewChild('wrapperDiv', { static: true }) wrapperDiv: ElementRef<HTMLElement>;
  dateModel: IDateInput = {} as IDateInput;
  errorId?: string;
  errorDescriptionId?: string;

  ngOnInit() {
    this.initialiseModel();
    this.form.valueChanges.subscribe(() => {
      this.initialiseModel();
    });
  }

  isValid(dayControl: NgModel, monthControl: NgModel, yearControl: NgModel) {
    const dirty = dayControl.dirty || monthControl.dirty || yearControl.dirty;
    const touched = dayControl.touched || monthControl.touched || yearControl.touched;
    return (dirty || touched) && this.formControl.valid;
  }

  isInvalid(dayControl: NgModel, monthControl: NgModel, yearControl: NgModel) {
    const dirty = dayControl.dirty || monthControl.dirty || yearControl.dirty;
    const touched = dayControl.touched || monthControl.touched || yearControl.touched;
    return (dirty || touched) && !this.formControl.valid;
  }

  updateModel(value, key) {
    this.dateModel[key] = value;
    this.patchValue();
  }

  onBlur() {
    this.formControl.markAsTouched();
    this.formControl.markAsDirty();
    this.patchValue();
  }

  onKeyup(event, nextFieldId: string) {
    const { which, target, shiftKey } = event;
    const { value, maxLength } = target;

    if ((nextFieldId && which === KeyCodes.Tab && shiftKey) || which === KeyCodes.Shift) {
      return;
    }

    if (nextFieldId && value.length >= maxLength) {
      const element: HTMLInputElement = this.wrapperDiv.nativeElement.querySelector(`#${nextFieldId}`);
      element.focus();
      this.formControl.markAsTouched();
      this.formControl.markAsDirty();
    }
  }

  onKeydown(event, currentFieldId: string) {
    const { which, target, shiftKey } = event;
    const { value, maxLength } = target;

    if (which === KeyCodes.Tab && !shiftKey && value.toString().length > 0) {
      this.dateModel[currentFieldId] = value.padStart(maxLength, '0');
    }
  }

  patchValue() {
    this.formControl.setValue(this.dateModel);
    this.form.patchValue([{ [this.field.key as string]: { ...this.dateModel } }]);
  }

  private initialiseModel() {
    this.dateModel = this.model ? this.model[this.field.key as string] ?? {} : {};
  }
}
